import { NSFWSelector } from "@web/route-services/index/NSFWSelector";
import { RankingButtons } from "@web/route-services/index/RankingButtons";
import { TagCombo } from "@web/route-services/index/TagCombo";
import { TagDisplay } from "@web/route-services/index/TagDisplay";
import { TimeFilterSelect } from "@web/route-services/index/TimeFilterSelect";
import { useTagNavigation } from "@web/route-services/index/use-tag-navigation";

/**
 * A component that renders the filtering / ranking options for the explore page.
 * This is meant to be used on Desktop only.
 * For the mobile version, see `Header.tsx
 */
export function ExploreControls() {
  const { add } = useTagNavigation();

  return (
    <div className="flex flex-col space-y-2">
      <RankingButtons />
      <div className="flex space-x-4">
        <TimeFilterSelect className="w-30 h-12 border-0 bg-transparent" />
        <NSFWSelector className="w-30 h-12 border-0 bg-transparent" />
        <TagCombo onTagSelect={add} />
        <TagDisplay />
      </div>
    </div>
  );
}
